/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Network_Page_DescriptionInputs */

const de_home_network_page_description = /** @type {(inputs: Home_Network_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwalten Sie das WLAN-Netzwerk, in dem Sie lizenzbeschränkte Sender auf Smartphone und Tablet empfangen können.`)
};

/** @type {(inputs: Home_Network_Page_DescriptionInputs) => LocalizedString} */
const en_home_network_page_description = de_home_network_page_description;

/**

* @param {Home_Network_Page_DescriptionInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const home_network_page_description = /** @type {((inputs?: Home_Network_Page_DescriptionInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Network_Page_DescriptionInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_home_network_page_description(inputs)
	return en_home_network_page_description(inputs)
});